import { render, staticRenderFns } from "./TaskMap.vue?vue&type=template&id=4c8d272c&scoped=true"
import script from "./TaskMap.vue?vue&type=script&lang=js"
export * from "./TaskMap.vue?vue&type=script&lang=js"
import style0 from "./TaskMap.vue?vue&type=style&index=0&id=4c8d272c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c8d272c",
  null
  
)

export default component.exports